<template>
	<div class="navBar">
		<div class="nav-list">
			<el-menu
				class="el-menu"
				background-color="#090723"
				text-color="#fff"
				router
				:default-active="routePath"
				active-text-color="#fc501c"
			>
				<el-menu-item index="/home">
					<svg-icon icon-class="home" />
					<span slot="title">首页</span>
				</el-menu-item>
				<el-submenu index="/goods">
					<template slot="title">
						<svg-icon icon-class="others" />
						<span slot="title">商品管理</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/goods/index">供应链商品库</el-menu-item>
						<el-menu-item index="/goods/classifyList"
							>商品分类管理</el-menu-item
						>
						<el-menu-item index="/goods/source">商品来源管理</el-menu-item>
						<el-menu-item index="/goods/freightTemplate">运费模版设置</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-submenu index="/orders">
					<template slot="title">
						<svg-icon icon-class="form" />
						<span slot="title">订单管理</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/orders/list">供应链订单</el-menu-item>
					</el-menu-item-group>
					<el-menu-item-group>
						<el-menu-item index="/orders/ownList">自产自销订单</el-menu-item>
					</el-menu-item-group>
					<el-menu-item-group>
						<el-menu-item index="/orders/safeguard"
							>供应链维权订单</el-menu-item
						>
					</el-menu-item-group>
					<el-menu-item-group>
						<el-menu-item index="/orders/unshipped">未发货订单</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<!-- <el-submenu index="/user">
					<template slot="title">
						<svg-icon icon-class="user" />
						<span slot="title">分销商账号管理</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/user/list">分销商渠道列表</el-menu-item>
						<el-menu-item index="/user/deductionRecord">分销商扣费记录</el-menu-item>
						<el-menu-item index="/user/rechargeRecord">分销商充值记录</el-menu-item>
					</el-menu-item-group>
				</el-submenu> -->
				<el-submenu index="/settings" v-if="is_root == 1">
					<template slot="title">
						<svg-icon icon-class="associat" />
						<span slot="title">系统设置</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/settings/api">系统接口设置</el-menu-item>
					</el-menu-item-group>
					<el-menu-item-group>
						<el-menu-item index="/settings/accounts">操作账号管理</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
			</el-menu>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import store from '@/store/index'
export default {
	computed: {
		...mapGetters(['routePath'])
	},
	data() {
		return {
			is_root: ''
		}
	},
	created() {
		this.is_root = store.getters.userIsRoot
	}
}
</script>
<style lang="scss">
.navBar {
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	overflow: hidden;
	width: 180px;
	float: left;
	height: 100%;
	background-color: #090723;
	color: #a1a1a1;
	text-align: center;
	position: relative;
	// padding-bottom: 100px;
	.nav-list {
		height: 100%;
		width: 240px;
		display: flex;
		justify-content: left;
		overflow-y: auto;
		overflow-x: hidden;
		.el-menu {
			display: inline-block;
			text-align: left;
			border-right: none;
			font-size: 28px;
			.svg-icon {
				margin-right: 5px;
				width: 24px;
				text-align: center;
				font-size: 18px;
				vertical-align: middle;
			}

			.el-menu-item-group {
				overflow-x: hidden;
			}
			.el-menu-item-group__title {
				padding: 0;
			}
			.el-menu-item,
			.el-submenu__title {
				&:hover {
					background-color: #3b5676 !important;
					color: #fff;
				}
			}
		}
		.el-menu:not(.el-menu--collapse) {
			width: 180px;
		}
		.router-link-active {
			color: #fc501c;
		}
	}
	// .logo {
	// 	position: absolute;
	// 	bottom: 38px;
	// 	left: 0;
	// 	text-align: center;
	// 	width: 100%;
	// 	.icon {
	// 		height: 38px;
	// 		width: 38px;
	// 		margin-bottom: 6px;
	// 		border-radius: 8px;
	// 	}
	// 	.version {
	// 		font-size: 12px;
	// 	}
	// }
}
</style>
